import { EntityRepository, Repository } from "typeorm";
import { CodeListLog } from "../code-list-log.entity";

@EntityRepository(CodeListLog)
export class CodeListlogRepository extends Repository<CodeListLog> {

}